import "./home.css";
import { useState, useEffect } from "react";
import { BasePage } from "../base/base";
import { Ascii } from "../components/ascii";
import { PixelRainContainer } from "../components/containers";

const Brand = () => {
  const brandMap = [
    "PWNED.PLACE",
    "PWNED.PLACE",
    "PWNED.PLACE",
    "$%!=0X+#~@E",
    "P%W#N@E!C:E",
    "PW4!=9>ÄCQE",
    "PW28HJV9C#E",
    "PWOE!C#JC@E",
    "PWN1#?B5%BH",
    "83ED.9%$2E$",
    "PWNED.PLACE",
    "PWNED.83759",
    "29568.%%$#@",
    "@@@@@@@@@@@",
    "X@@@@@@@@@@",
    "XBJdsOsdvlk",
    "§$!cKf0?%&V",
    "1Hc7yuxpHSx",
    "o5UJ3HiJLT5",
    "PQbW8fwyA4N",
    "PWNED.7g2vN",
    "PWNw90Jn73o",
    "C9ijbQPLACE",
    "t0rBHbPLmoU",
    "FMwWW.Pc78G",
    "GQED.fwyA4N",
    "fQEED.Pg2CE",
    "B7vw90Jn73o",
    "C9ijbQAFQ9y",
    "t0rBHbWFmoU",
    "FMwQW0sc78G",
  ];
  const [brand, setBrand] = useState(brandMap[0]);
  const loopUpdate = (i) => {
    i = i + Math.floor(Math.random() * brandMap.length * 1.5);
    let timeout = 100;
    if (i >= brandMap.length) {
      i = 0;
      timeout = 300;
    }
    setBrand(brandMap[i]);
    setTimeout(() => loopUpdate(i), timeout);
  };

  useEffect(() => {
    loopUpdate(0);
  }, []);
  return <h1 className="brand">{brand}</h1>;
};

const HomePage = () => {
  return (
    <BasePage>
      <PixelRainContainer style={{ width: "100vw", height: "100vh" }}>
        <span className="home-welcome-to">Welcome to</span>
        <Brand />
      </PixelRainContainer>
    </BasePage>
  );
};

export { HomePage };
